import React, { useMemo } from "react";
import { useData, ADMIN_TABLE } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, STATUS_OPTIONS } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";

export default function CreatedTasks() {
  const { adminRecords, loading } = useData();
  const { user } = useAuth();
  const created = useMemo(() =>
    adminRecords.filter(r => {
      const tc = r.fields?.["Task Creator"];
      // Task Creator might be resolved to string by worker
      if (typeof tc === "string" && tc.toLowerCase().includes((user?.name || "").toLowerCase())) return true;
      // Or it might still be a person object
      if (userMatchesField(tc, user)) return true;
      // Fallback to Supervisor (the supervisor has creator rights to edit/delete)
      if (userMatchesField(r.fields?.["Supervisor"], user)) return true;
      // Fallback to Assigned By
      return userMatchesField(r.fields?.["Assigned By"], user);
    }),
    [adminRecords, user]
  );
  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;
  return (
    <div className="fade-in">
      <TaskTable
        title="📝 Tasks I Created"
        records={created}
        tableId={ADMIN_TABLE}
        canEdit
        canDelete
        statusOptionsOverride={STATUS_OPTIONS}
        emptyMsg="You haven't created any tasks yet."
        kanbanLayout="createdTask9col"
      />
    </div>
  );
}
